<template>
  <div id="FullTextContentoperation" class="aqt_su">
    <div v-if="pdfUrl" class="showPdf" :style="{borderRight: isContent>0?'1px solid #e8eaec':''}">
      <iframe style="width: 100%;height:100%;overflow: auto;" :src="'/pdf/web/viewer.html?file=' + pdfUrl"
              frameborder="0"></iframe>
    </div>
    <div class="showRight" v-if="isContent>0" :style="{width:jg_page==1||jg_page==2||jg_page==3||jg_page==4?'58vw':'60vw'}">
      <div class="contentTop">
        <!--操作-->
        <div v-if="ShowOpertion=='opertion'" class="SealectBox">
          <!--          筛选-->
          <Input v-model="query.num" clearable search :placeholder="$t('m.infor_page')"
                 style="margin:0 5px 5px 0;height:180px;" @on-search="selData"
                 @on-clear="selData"/>
          <Input v-model="query.pdfnum" clearable search :placeholder="$t('m.file_page')"
                 style="margin:0 5px 5px 0;height:190px;" @on-search="selData"
                 @on-clear="selData"/>

          <Button class="aqt_lang_mn titlefont" style="margin:0 9px 0px 0" type="primary" @click="selData"
                  :disabled="(query.num || query.pdfnum ) ? false : true">{{ $t('m.search') }}
          </Button>

        </div>
        <!--分页-->
        <div v-if="ShowOpertion=='page'" class="SealectBox">
          <div class="page_box">
            <div class="page_item aqt_no_su" :class="activeIndex==item1.page?'page_item_active':'page_item_class'"
                 v-for="(item1,index1) in PageList" :key="index1" @click="getPage(item1)">
              {{item1.page}}
            </div>
          </div>
        </div>
        <!--内容-->
        <div class="scollerBox of aqt_lang_mn titlefont" >
          <template v-if="!showNo">
            <div v-if="jg_page==1&&textContentList.length" class="structure_1">
              <div class="structure_content of"
                   v-html="textContentList[0].contentlangText"
                   :style="{fontSize:indexFontSize_1+'!important',wordBreak:textContentList[0].contentClass}"></div>
              <div class="structure_operation">
                <Button size="small" class="bottomsmall" @click="getEdit(textContentList[0])" type="primary">{{
                    $t('m.copy_text')
                  }}
                </Button>
                <Select v-model="indexFontSize_1" class="Selectsmall" placement="bottom-end"
                        transfer-class-name="transferLeft">
                  <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                </Select>
              </div>
            </div>
            <div v-if="jg_page==2&&textContentList.length" class="structure_2">
              <Split v-model="split5" mode="vertical">
                <template #top>
                  <div class="two_module">
                    <div class="structure_content of"
                         v-html="textContentList[0].contentlangText"
                         :style="{fontSize:indexFontSize_1+'!important',wordBreak:textContentList[0].contentClass}"></div>
                    <div class="structure_operation">
                      <Button size="small" class="bottomsmall" type="primary" @click="getEdit(textContentList[0])">
                        {{ $t('m.copy_text') }}
                      </Button>
                      <Select v-model="indexFontSize_1" class="Selectsmall" placement="bottom-end"
                              transfer-class-name="transferLeft">
                        <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                      </Select>
                    </div>
                  </div>
                </template>
                <template #bottom>
                  <div class="two_module">
                    <div class="structure_content of"
                         v-html="textContentList[1].contentlangText"
                         :style="{fontSize:indexFontSize_2+'!important',wordBreak:textContentList[1].contentClass}"></div>
                    <div class="structure_operation">
                      <Button size="small" class="bottomsmall" @click="getEdit(textContentList[1])" type="primary">
                        {{ $t('m.copy_text') }}
                      </Button>
                      <Select v-model="indexFontSize_2" class="Selectsmall" placement="bottom-end"
                              transfer-class-name="transferLeft">
                        <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                      </Select>
                    </div>
                  </div>
                </template>
              </Split>
            </div>
            <div v-if="jg_page==3&&textContentList.length" class="structure_3">
              <div class="structure_3_left">
                <div class="structure_3_left_top">
                  <div class="structureTopcontent of"
                       v-html="textContentList[0].contentlangText"
                       :style="{fontSize:indexFontSize_1+'!important',wordBreak:textContentList[0].contentClass}"></div>
                  <div class="structureBootomOperation">
                    <Button size="small" class="bottomsmall" @click="getEdit(textContentList[0])" type="primary">
                      {{ $t('m.copy_text') }}
                    </Button>
                    <Select v-model="indexFontSize_1" class="Selectsmall" placement="bottom-end"
                            transfer-class-name="transferRight">
                      <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                    </Select>
                  </div>
                </div>
                <div class="structure_3_left_bottom">
                  <div class="structureTopcontent of"
                       v-html="textContentList[1].contentlangText"
                       :style="{fontSize:indexFontSize_2+'!important',wordBreak:textContentList[1].contentClass}"></div>
                  <div class="structureBootomOperation">
                    <Button size="small" class="bottomsmall" @click="getEdit(textContentList[1])" type="primary">
                      {{ $t('m.copy_text') }}
                    </Button>
                    <Select v-model="indexFontSize_2" class="Selectsmall" placement="bottom-end"
                            transfer-class-name="transferRight">
                      <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                    </Select>
                  </div>
                </div>
              </div>
              <div class="structure_3_right">
                <div class="structure_content of"
                     v-html="textContentList[2].contentlangText"
                     :style="{fontSize:indexFontSize_3+'!important',wordBreak:textContentList[2].contentClass}"></div>
                <div class="structure_operation">
                  <Button size="small" class="bottomsmall" @click="getEdit(textContentList[2])" type="primary">
                    {{ $t('m.copy_text') }}
                  </Button>
                  <Select v-model="indexFontSize_3" class="Selectsmall" placement="bottom-end"
                          transfer-class-name="transferLeft">
                    <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div v-if="jg_page==4&&textContentList.length" class="structure_4">
              <div class="structure_4_box">
                <div class="structure_content of"
                     v-html="textContentList[0].contentlangText"
                     :style="{fontSize:indexFontSize_1+'!important',wordBreak:textContentList[0].contentClass}"></div>
                <div class="structure_operation">
                  <Button size="small" class="bottomsmall" @click="getEdit(textContentList[0])" type="primary">
                    {{ $t('m.copy_text') }}
                  </Button>
                  <Select v-model="indexFontSize_1" class="Selectsmall" placement="bottom-end"
                          transfer-class-name="transferLeft">
                    <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                  </Select>
                </div>
              </div>
              <div class="structure_4_box">
                <div class="structure_content of"
                     v-html="textContentList[1].contentlangText"
                     :style="{fontSize:indexFontSize_2+'!important',wordBreak:textContentList[1].contentClass}"></div>
                <div class="structure_operation">
                  <Button size="small" class="bottomsmall" @click="getEdit(textContentList[1])" type="primary">
                    {{ $t('m.copy_text') }}
                  </Button>
                  <Select v-model="indexFontSize_2" class="Selectsmall" placement="bottom-end"
                          transfer-class-name="transferLeft">
                    <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                  </Select>
                </div>
              </div>
              <div class="structure_4_box">
                <div class="structure_content of"
                     v-html="textContentList[2].contentlangText"
                     :style="{fontSize:indexFontSize_3+'!important',wordBreak:textContentList[2].contentClass}"></div>
                <div class="structure_operation">
                  <Button size="small" class="bottomsmall" @click="getEdit(textContentList[2])" type="primary">
                    {{ $t('m.copy_text') }}
                  </Button>
                  <Select v-model="indexFontSize_3" class="Selectsmall" placement="bottom-end"
                          transfer-class-name="transferLeft">
                    <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                  </Select>
                </div>
              </div>
              <div class="structure_4_box">
                <div class="structure_content of"
                     v-html="textContentList[3].contentlangText"
                     :style="{fontSize:indexFontSize_4+'!important',wordBreak:textContentList[3].contentClass}"></div>
                <div class="structure_operation">
                  <Button size="small" class="bottomsmall" @click="getEdit(textContentList[3])" type="primary">
                    {{ $t('m.copy_text') }}
                  </Button>
                  <Select v-model="indexFontSize_4" class="Selectsmall" placement="bottom-end"
                          transfer-class-name="transferLeft">
                    <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div v-if="jg_page==5&&textContentList.length" class="structure_5">
              <Split v-model="split3">
                <template #left>
                  <div class="structure_5_1">
                    <div class="structureTopcontent of"
                         v-html="textContentList[0].contentlangText"
                         :style="{fontSize:indexFontSize_1+'!important',wordBreak:textContentList[0].contentClass}"></div>
                    <div class="structureBootomOperation">
                      <Button size="small" class="bottomsmall" @click="getEdit(textContentList[0])" type="primary">
                        {{ $t('m.copy_text') }}
                      </Button>
                      <Select v-model="indexFontSize_1" class="Selectsmall" placement="bottom-end"
                              transfer-class-name="transferRight">
                        <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                      </Select>
                    </div>
                  </div>
                  <div class="structure_5_2">
                    <div class="structureTopcontent of"
                         v-html="textContentList[1].contentlangText"
                         :style="{fontSize:indexFontSize_2+'!important',wordBreak:textContentList[1].contentClass}"></div>
                    <div class="structureBootomOperation">
                      <Button size="small" class="bottomsmall" @click="getEdit(textContentList[1])" type="primary">
                        {{ $t('m.copy_text') }}
                      </Button>
                      <Select v-model="indexFontSize_2" class="Selectsmall" placement="bottom-end"
                              transfer-class-name="transferRight">
                        <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                      </Select>
                    </div>
                  </div>
                  <div class="structure_5_3">
                    <div class="structureTopcontent of"
                         v-html="textContentList[2].contentlangText"
                         :style="{fontSize:indexFontSize_3+'!important',wordBreak:textContentList[2].contentClass}"></div>
                    <div class="structureBootomOperation">
                      <Button size="small" class="bottomsmall" @click="getEdit(textContentList[2])" type="primary">
                        {{ $t('m.copy_text') }}
                      </Button>
                      <Select v-model="indexFontSize_3" class="Selectsmall" placement="bottom-end"
                              transfer-class-name="transferRight">
                        <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                      </Select>
                    </div>
                  </div>
                </template>
                <template #right>
                  <div class="structure_5_right">
                    <Split v-model="split5" mode="vertical">
                      <template #top>
                        <div class="structure_5_4">
                          <div class="structure_content of"
                               v-html="textContentList[3].contentlangText"
                               :style="{fontSize:indexFontSize_4+'!important',wordBreak:textContentList[3].contentClass}"></div>
                          <div class="structure_operation">
                            <Button size="small" class="bottomsmall" @click="getEdit(textContentList[3])"
                                    type="primary">
                              {{ $t('m.copy_text') }}
                            </Button>
                            <Select v-model="indexFontSize_4" class="Selectsmall" placement="bottom-end"
                                    transfer-class-name="transferLeft">
                              <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{
                                  item
                                }}
                              </Option>
                            </Select>
                          </div>
                        </div>
                      </template>
                      <template #bottom>
                        <div class="structure_5_5">
                          <div class="structure_content of"
                               v-html="textContentList[4].contentlangText"
                               :style="{fontSize:indexFontSize_5+'!important',wordBreak:textContentList[4].contentClass}"></div>
                          <div class="structure_operation">
                            <Button size="small" class="bottomsmall" @click="getEdit(textContentList[4])"
                                    type="primary">
                              {{ $t('m.copy_text') }}
                            </Button>
                            <Select v-model="indexFontSize_5" class="Selectsmall" placement="bottom-end"
                                    transfer-class-name="transferLeft">
                              <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{
                                  item
                                }}
                              </Option>
                            </Select>
                          </div>
                        </div>
                      </template>
                    </Split>
                  </div>
                </template>
              </Split>


            </div>
            <div v-if="jg_page==6" class="structure_6">
              <Split v-model="split3">
                <template #left>
                  <div class="structure_6_1">
                    <div class="structureTopcontent of"
                         v-html="textContentList[0].contentlangText"
                         :style="{fontSize:indexFontSize_1+'!important',wordBreak:textContentList[0].contentClass}"></div>
                    <div class="structureBootomOperation">
                      <Button size="small" class="bottomsmall" @click="getEdit(textContentList[0])" type="primary">
                        {{ $t('m.copy_text') }}
                      </Button>
                      <Select v-model="indexFontSize_1" class="Selectsmall" transfer-class-name="transferRight"
                              placement="bottom-end">
                        <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                      </Select>
                    </div>
                  </div>
                  <div class="structure_6_2">
                    <div class="structureTopcontent of"
                         v-html="textContentList[1].contentlangText"
                         :style="{fontSize:indexFontSize_2+'!important',wordBreak:textContentList[1].contentClass}"></div>
                    <div class="structureBootomOperation">
                      <Button size="small" class="bottomsmall" @click="getEdit(textContentList[1])" type="primary">
                        {{ $t('m.copy_text') }}
                      </Button>
                      <Select v-model="indexFontSize_2" class="Selectsmall" transfer-class-name="transferRight"
                              placement="bottom-end">
                        <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                      </Select>
                    </div>
                  </div>
                  <div class="structure_6_3">
                    <div class="structureTopcontent of"
                         v-html="textContentList[2].contentlangText"
                         :style="{fontSize:indexFontSize_3+'!important',wordBreak:textContentList[2].contentClass}"></div>
                    <div class="structureBootomOperation">
                      <Button size="small" class="bottomsmall" @click="getEdit(textContentList[2])" type="primary">
                        {{ $t('m.copy_text') }}
                      </Button>
                      <Select v-model="indexFontSize_3" class="Selectsmall" placement="bottom-end"
                              transfer-class-name="transferRight">
                        <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                      </Select>
                    </div>
                  </div>
                </template>
                <template #right>
                  <div class="structure_6_right">
                    <Split v-model="split5" mode="vertical">
                      <template #top>
                        <div class="structure_6_4">
                          <div class="structure_content of"
                               v-html="textContentList[3].contentlangText"
                               :style="{fontSize:indexFontSize_4+'!important',wordBreak:textContentList[3].contentClass}"></div>
                          <div class="structure_operation">
                            <Button size="small" class="bottomsmall" @click="getEdit(textContentList[3])"
                                    type="primary">
                              {{ $t('m.copy_text') }}
                            </Button>
                            <Select v-model="indexFontSize_4" class="Selectsmall" placement="bottom-end"
                                    transfer-class-name="transferLeft">
                              <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{
                                  item
                                }}
                              </Option>
                            </Select>
                          </div>
                        </div>
                      </template>
                      <template #bottom>
                        <div class="structure_6_5">
                          <div class="structure_content of"
                               v-html="textContentList[4].contentlangText"
                               :style="{fontSize:indexFontSize_5+'!important',wordBreak:textContentList[4].contentClass}"></div>
                          <div class="structure_operation">
                            <Button size="small" class="bottomsmall" @click="getEdit(textContentList[4])"
                                    type="primary">
                              {{ $t('m.copy_text') }}
                            </Button>
                            <Select v-model="indexFontSize_5" class="Selectsmall" placement="bottom-end"
                                    transfer-class-name="transferLeft">
                              <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{
                                  item
                                }}
                              </Option>
                            </Select>
                          </div>
                        </div>
                      </template>
                    </Split>
                  </div>
                  <div class="structure_6_6">
                    <div class="structureTopcontent of"
                         v-html="textContentList[5].contentlangText"
                         :style="{fontSize:indexFontSize_6+'!important',wordBreak:textContentList[5].contentClass}"></div>
                    <div class="structureBootomOperation">

                      <Button size="small" class="bottomsmall" @click="getEdit(textContentList[5])" type="primary">
                        {{ $t('m.copy_text') }}
                      </Button>
                      <Select v-model="indexFontSize_6" class="Selectsmall" placement="bottom-end"
                              transfer-class-name="transferLeft">
                        <Option v-for="(item, index) in fontsizeList" :value="item" :key="index">{{ item }}</Option>
                      </Select>
                    </div>
                  </div>
                </template>
              </Split>


            </div>
          </template>
          <div v-if="showNo" class="noData mn_font aqt_lang_mn titlefont">{{ $t('m.no_data') }}</div>
          <!-- <Spin v-if="listload" size="large"
                style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;position: absolute;top:0;left: 0"/> -->
                <AqtSpin v-if="listload"></AqtSpin>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  props: {
    infoId: {
      type: [Boolean, Number, String],
      default: false,//主键id
    },
    type: {//1.书2.期刊 杂志（包含论文）3报刊4普通论文
      type: [String, Number],
      default: '',
    },
    pdfUrl: {//pdf地址
      type: [String],
      default: '',
    },
    isContent: { //是否有文字内容 0没有 大于0 有并且是内容id
      type: [Number, String],
      default: 0
    },
    directoryId: {
      type: [Boolean, Number, String],
      default: false,//目录id
    },
    ShowOpertion: {
      type: [String],
      default: 'opertion',//线上分页还是操作选框  操作：opertion  分页：page
    },
  },
  data() {
    return {
      showNo: false,
      query: {
        type: '',//1.书2.杂志（包含论文）3报刊4普通论文
        id: '',//书/期刊/论文/报刊主键id
        num: '',//资料页码
        pdfnum: '',//文件页码
        directory_id: '',//目录id 不是必填
      },

      textContentList: [],//文本内容列表

      listload: false,

      jg_page: 0,//结构页码
      fontsizeList: ['10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px'],
      indexFontSize_1: '14px',
      indexFontSize_2: '20px',
      indexFontSize_3: '16px',
      indexFontSize_4: '18px',
      indexFontSize_5: '18px',
      indexFontSize_6: '14px',

      split3: 0.3,
      split5: 0.5,
      split2: 0.2,

      condition: {
        content_id: '',
        directory_id:''
      },
      PageList: [],
      activeIndex:0

    };
  },
  methods: {
    /************************************************************
     * 处理数据
     ************************************************************/
    matchChinese(str) {
      if (!str) {
        return str;
      }
      let arr = str.split(" ");
      // let reg = /[\u4e00-\u9fa5\u3000-\u303f]/g; //中文+中文符合
      let reg = /[\u4e00-\u9fa5]/g; //中文
      let strarr = str.match(reg)

      if (arr.length && strarr && strarr.length) {
        strarr.forEach(element => {
          let replacestr
          let search = new RegExp(element, 'g');

          replacestr = `<span style="writing-mode:horizontal-tb!important;
display: contents!important;">${element}</span>`

          str = str.replace(search, replacestr);
        });
      }
      return str
    },
    //获取右边文本内容(操作搜索的)
    selData() {
      let that = this
      if (!that.query.num && !that.query.pdfnum) {
        that.$Message.error('文件页码和资料页码不得同时为空');
        return
      }
      that.textContentList = []
      that.jg_page = 0
      that.listload = true
      that.showNo = false
      that.query.type = that.type
      that.query.id = that.infoId
      that.query.directory_id = that.directoryId
      that.$httpsencrypt.post('api/web/v3/content/newindex', that.query).then(val => {
        if (val.code == 200 && val.data.length) {
          that.jg_page = val.data.length
          that.textContentList = val.data.map(it => {
            return {
              ...it,
              contentlangText: that.$webcrypto.get(it.contentlang) ?
                  (that.$webcrypto.get(it.contentlang).mn ? that.matchChinese(that.$webcrypto.get(it.contentlang).mn) :
                      (that.$webcrypto.get(it.contentlang).zh ? that.$webcrypto.get(it.contentlang).zh :
                          ''))
                  : '',
              contentClass: that.$webcrypto.get(it.contentlang) ? (that.$webcrypto.get(it.contentlang).mn ? '' : (that.$webcrypto.get(it.contentlang).zh ? 'break-all' : '')) : '',
            }
          })
          that.showNo = false
        } else {
          that.jg_page = 0
          that.textContentList = []
          that.showNo = true
        }
        that.listload = false
      }).catch(e => {
        that.listload = false
      })
    },

    //点击编辑按钮
    getEdit(value) {
      let that = this
      let inputDom = document.createElement('textarea') // js创建一个文本框
      document.body.appendChild(inputDom) //将文本框暂时创建到实例里面
      inputDom.value = that.htmlToString(value.contentlangText) //将需要复制的内容赋值到创建的文本框中
      inputDom.select() //选中文本框中的内容
      inputDom.focus()
      document.execCommand('copy') //执行复制操作
      document.body.removeChild(inputDom) //最后移出
      that.$Message.success(that.$t('m.text_order_copy'))
    },

    htmlToString(htmlStr) {
      return htmlStr.replace(/<\/?.+?\/?>|\r|\n/g, ' ')
    },
    //请求文本内容（目录的文本内容-默认请求）
    getDate(isContent) {
      let that = this
      that.textContentList = []
      that.jg_page = 0
      that.condition.directory_id = that.directoryId
      that.condition.content_id = isContent
      that.showNo = false
      that.listload = true
      that.$httpsencrypt.post('api/web/v3/content/find', that.condition).then(val => {
        if (val.code == 200&&val.data) {
          if(val.data.contentlist&&val.data.contentlist.length){
            that.jg_page = val.data.contentlist.length
            that.textContentList = val.data.contentlist.map(it => {
              return {
                ...it,
                contentlangText: it.mn ?that.matchChinese(it.mn):(it.zh?it.zh:''),
                contentClass: it.mn ? '' : (it.zh ? 'break-all' : '')
              }
            })
          }
          that.PageList = val.data.page_list
          that.activeIndex =val.data.per_page
          that.showNo = false
        } else {
          that.jg_page = 0
          that.textContentList = []
          that.PageList = []
          that.showNo = true
        }
        that.listload = false
      }).catch(e => {
        that.listload = false
      })

    },
    getPage(item){
      this.activeIndex = item.page
      this.getDate(item.content_id)
    }


  },
  mounted() {
    if (this.directoryId&&this.isContent) {
      this.getDate(this.isContent)
    }
  },
  created() {
  },
};
</script>

<style lang="less" scoped>
#FullTextContentoperation {
  max-width: 92vw;
  height: 100%;
  overflow: hidden;
  padding: 27px 10px;
  background: #ffffff;

  .bottomsmall {
    display: flex !important;
    align-items: center !important;
    margin: 2px !important;
  }

  .Selectsmall {
    height: 60px !important;
    margin: 2px !important;
  }

  .showPdf {
    //width: 35%;
    width: 35vw;
    height: 100%;
    padding-right: 10px;
  }

  .of {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .showRight {
    //width: 65%;
    width: 60vw;
    height: 100%;
    display: flex;

    .contentTop {
      width: 100%;
      height: 100%;
      padding-left: 7px;

      .SealectBox {
        min-width: 45px;
        height: 100%;
        margin-right: 10px;
        border-right: 1px solid #e8eaec;
        .page_box{
          width: 100%;
          height: 100%;
          display: flex;
          overflow-y: auto;
          .page_item{
            margin-bottom: 10px;
            min-width: 35px;
            height: 35px;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            cursor: pointer;
          }
          .page_item:hover{
            color: #ffffff;
            background: var(--themeColor);
            border: 1px solid var(--themeColor);
          }
          .page_item_class{
            color: #666666;
            background: #ffffff;
            border: 1px solid #dcdee2;
          }
          .page_item_active{
            color: #ffffff;
            background: var(--themeColor);
            border: 1px solid var(--themeColor);
          }
        }
        .page_box::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
          height: 8px;
        }

        .page_box::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 5px;
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: rgba(0, 0, 0, 0.2);
        }

        .page_box::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 0;
          background: rgba(0, 0, 0, 0.1);
        }
      }

      .scollerBox {
        width: calc(100% - 100px);
        height: 100%;
        position: relative;
        //border: 1px solid #e8eaec;

        .structure_content {
          width: calc(100% - 50px);
          height: 100%;
          color: #333333;
          //border-right: 1px solid #e8eaec;
          padding: 10px;

          p {
            font-size: inherit !important;

            span {
              font-size: inherit !important;
            }
          }

          span {
            font-size: inherit !important;
          }
        }

        .structure_operation {
          width: 50px;
          height: 100%;
          display: flex;
          align-items: center;
          padding-top: 10px;
        }

        .structureTopcontent {
          width: 100%;
          height: calc(100% - 70px);
          color: #333333;
          //border-right: 1px solid #e8eaec;
          padding: 10px;

          p {
            font-size: inherit !important;

            span {
              font-size: inherit !important;
            }
          }

          span {
            font-size: inherit !important;
          }
        }

        .structureBootomOperation {
          width: 100%;
          height: 70px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: center;
          padding-right: 10px;
        }

        .structure_1 {
          width: 100%;
          height: 100%;
          border: 1px solid #e8eaec;
        }

        .structure_2 {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;

          .two_module {
            width: 100%;
            //height: calc(calc(100% - 5px) / 2);
            height: 100%;
            border: 1px solid #e8eaec;
          }
        }

        .structure_3 {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .structure_3_left {
            width: 250px;
            height: 100%;
            display: flex;
            justify-content: space-between;

            .structure_3_left_top {
              width: 100%;
              height: calc(calc(100% - 5px) / 2);
              border: 1px solid #e8eaec;
              display: flex;
            }

            .structure_3_left_bottom {
              width: 100%;
              height: calc(calc(100% - 5px) / 2);
              border: 1px solid #e8eaec;
              display: flex;

            }
          }

          .structure_3_right {
            //width: 100%;
            width: calc(100% - 255px);
            height: 100%;
            border: 1px solid #e8eaec;
          }
        }

        .structure_4 {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;

          .structure_4_box {
            width: 100%;
            height: calc(calc(100% - 15px) / 4);
            border: 1px solid #e8eaec;
          }
        }

        .structure_5 {
          width: 100%;
          height: 100%;

          .structure_5_1 {
            //width: 100px;
            width: 31%;
            height: 100%;
            margin-right: 5px;
            border: 1px solid #e8eaec;
            display: flex;
          }

          .structure_5_2 {
            //width: 135px;
            width: 32%;
            height: 100%;
            margin-right: 5px;
            border: 1px solid #e8eaec;
            display: flex;
          }

          .structure_5_3 {
            //width: 115px;
            width: 32%;
            height: 100%;
            margin-right: 5px;
            border: 1px solid #e8eaec;
            display: flex;
          }

          .structure_5_right {
            //width: calc(100% - 365px);
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;

            .structure_5_4 {
              width: 100%;
              //height: calc(calc(100% - 5px) / 2);
              height: 100%;
              border: 1px solid #e8eaec;
            }

            .structure_5_5 {
              width: 100%;
              //height: calc(calc(100% - 5px) / 2);
              height: 100%;
              border: 1px solid #e8eaec;
            }
          }
        }

        .structure_6 {
          width: 100%;
          height: 100%;

          .structure_6_1 {
            //width: 100px;
            width: 31%;
            height: 100%;
            margin-right: 5px;
            border: 1px solid #e8eaec;
            display: flex;
          }

          .structure_6_2 {
            //width: 135px;
            width: 32%;
            height: 100%;
            margin-right: 5px;
            border: 1px solid #e8eaec;
            display: flex;
          }

          .structure_6_3 {
            //width: 115px;
            width: 32%;
            height: 100%;
            margin-right: 5px;
            border: 1px solid #e8eaec;
            display: flex;
          }

          .structure_6_right {
            //width: calc(100% - 470px);
            width: 85%;
            height: 100%;
            margin-right: 5px;
            display: flex;
            justify-content: space-between;

            .structure_6_4 {
              width: 100%;
              //height: calc(calc(100% - 5px) / 2);
              height: 100%;
              border: 1px solid #e8eaec;
            }

            .structure_6_5 {
              width: 100%;
              //height: calc(calc(100% - 5px) / 2);
              height: 100%;
              border: 1px solid #e8eaec;
            }
          }

          .structure_6_6 {
            width: calc(15% - 5px);
            height: 100%;
            border: 1px solid #e8eaec;
            display: flex;
          }
        }

        .noData {
          width: 80px;
          height: 100%;
          font-size: 18px;
          color: #888888;
          padding: 5px 20px;
          display: flex;
          justify-content: center;
          align-items: center;

        }
      }
    }

  }
}
</style>

<style lang="less">
#FullTextContentoperation {
  .ivu-input-inner-container {
    width: 40px !important;
    height: 100%;
  }

  .ivu-input {
    height: 100% !important;
    line-height: 40px !important;
    padding: 7px 4px !important;
    font-size: 16px !important;
    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;
    font-family: "MHR8102" !important;
  }

  .ivu-input::-webkit-input-placeholder { /* WebKit browsers */
    position: absolute;
    left: 10px !important;
    font-size: 16px !important;
    font-family: "MHR8102" !important;
  }

  .ivu-input-icon {
    bottom: 0 !important;
    right: 7px !important;
  }

  .ivu-btn {
    padding: 15px 2px !important;
    font-size: 14px !important;
    width: 34px !important;
    font-family: "MHR8102" !important;

    span {
      vertical-align: unset !important;
    }
  }

  .ivu-select {
    width: 32px !important;
  }

  .ivu-select-selection {
    width: 100% !important;
    height: 100% !important;
  }

  .ivu-select-selected-value {
    height: 60px !important;
    padding: 8px 0 24px 0 !important;
    line-height: 32px !important;
  }
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
    color:#515a6e!important;
  }

  .ivu-select-arrow {
    top: 85% !important;
  }

  .ivu-select {
    display: flex;
    position: relative !important;
  }

  .transferLeft {
    top: 0px !important;
    left: -350px !important;
    will-change: right, right !important;
    transform-origin: left !important;
    height: auto !important;
    margin: 0 5px !important;
    padding: 0 !important;
    width: 340px !important;
    display: inherit;
    z-index: 999999 !important;
    background: var(--themeColor) !important;
  }

  .ivu-select-item {
    padding: 16px 7px !important;
  }

  .transferRight {
    top: 0px !important;
    left: 32px !important;
    will-change: right, right !important;
    transform-origin: left !important;
    height: auto !important;
    margin: 0 5px !important;
    padding: 0 !important;
    width: 340px !important;
    display: inherit;
    z-index: 999999 !important;
    background: var(--themeColor) !important;
  }

}
</style>
